import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SettingsContextProvider } from './contexts/SettingsContext';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');
// Create a root instance
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <SettingsContextProvider>
        <App />
      </SettingsContextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
